
import { fns, libTypes } from "@holta/lib";
import { useStore } from "../../config/store";
import { getEditOrder } from "./getEditOrder";
import {create} from 'mutative';

export const setOrderStatus = (orderStatus: libTypes.Order['orderStatus']) => {

    const editOrder = getEditOrder();

    useStore.setState({
        editOrder : create(editOrder, draft => {
            draft.newValues.order.orderStatus = fns.order.set.orderStatus(orderStatus);
        })
    });
};